import React, { useState, useEffect, useCallback } from 'react';
import styles from './SaleManagementTab.module.css';
import Calendar from 'components/common/Calendar/Calendar';

import Api from 'utils/api';

const SaleManagementTab = () => {
  const [salesData, setSalesData] = useState({});
  const [monthlyTotal, setMonthlyTotal] = useState(0);
  const [viewYear, setViewYear] = useState(new Date().getFullYear());
  const [viewMonth, setViewMonth] = useState(new Date().getMonth() + 1);
  const [loading, setLoading] = useState(false);

  // --- 매출 합계 ---
  const fetchRevenueSum = useCallback(async (start, end) => {

    const data = await Api.get(`/sale/revenue/sum?startLocalDateTime=${start}&endLocalDateTime=${end}`);
    return data.saleRevenue || 0;
    
  }, []);

  // --- 일별 매출 ---
  const fetchDailyRevenue = useCallback(async (start, end) => {

    const data = await Api.get(`/sale/revenue/date?startLocalDateTime=${start}&endLocalDateTime=${end}`);
    return data.saleRevenueMap || {};
  }, []);

  // --- 월 변경 시 호출 ---
  const handleFetchMonthData = useCallback(async (startISO, endISO) => {
    setLoading(true);

    const [year, month] = startISO.split('-');
    setViewYear(parseInt(year));
    setViewMonth(parseInt(month));

    const dailyRes = await fetchDailyRevenue(startISO, endISO);
    const totalRes = await fetchRevenueSum(startISO, endISO);

    setSalesData(dailyRes);
    setMonthlyTotal(totalRes);
    setLoading(false);
  }, [fetchDailyRevenue, fetchRevenueSum]);



  useEffect(() => {
    const now = new Date();
    const y = now.getFullYear();
    const m = now.getMonth();

    const start = `${y}-${String(m + 1).padStart(2, '0')}-01T00:00:00`;
    const end = `${y}-${String(m + 2).padStart(2, '0')}-01T00:00:00`;

    handleFetchMonthData(start, end);
  }, [handleFetchMonthData]);

  return (
    <div className={styles.container}>
      <div className={styles.summaryCard}>
        <h2 className={styles.title}>
          {viewYear}년 {String(viewMonth).padStart(2, '0')}월 매출
        </h2>

        <div className={loading ? styles.loading : styles.amount}>
          {loading ? "로딩 중..." : `${monthlyTotal.toLocaleString()}원`}
        </div>
      </div>

      <Calendar
        salesData={salesData}
        onFetchData={handleFetchMonthData}
      />
    </div>
  );
};

export default SaleManagementTab;